import React from "react";
import moment from "moment";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../Utils/renderField/renderReadField";
import { LAB_PRODUCCION_ESTADOS_DRC } from "../../../../../../../utility/constants";

const ESTADOS_ANALISIS = {
    [LAB_PRODUCCION_ESTADOS_DRC.PENDIENTE_ANALISIS]: {
        label: "Pendiente de análisis",
        alerta: "alert-warning",
    },
    [LAB_PRODUCCION_ESTADOS_DRC.DRC_RECHAZADO]: {
        label: "Pendiente de análisis",
        alerta: "alert-warning",
    },
    [LAB_PRODUCCION_ESTADOS_DRC.PENDIENTE_VALIDAR_DRC]: {
        label: "Análisis realizado, pendiente de validación",
        alerta: "alert-info",
    },
    [LAB_PRODUCCION_ESTADOS_DRC.DRC_VALIDO]: {
        label: "Análisis completado",
        alerta: "alert-success",
    },
};

// Lectura del análisis de DRC del sobrante pesado en el almacén. El DRC y los kg
// secos solo existen cuando el laboratorio ya validó el resultado
export const AnalisisSobranteConsulta = ({ analisis }) => {
    if (!analisis) {
        return (
            <React.Fragment>
                <h4 className="mt-4 mb-3">Análisis de DRC del sobrante</h4>
                <div className="alert alert-info text-center font-weight-bold">
                    Este almacén no tiene análisis de DRC registrados.
                </div>
            </React.Fragment>
        );
    }

    const estado = ESTADOS_ANALISIS[analisis.estado];
    const drcValidado =
        analisis.estado === LAB_PRODUCCION_ESTADOS_DRC.DRC_VALIDO;

    return (
        <div className="card mb-3 mt-4">
            <div className="card-body">
                <h4 className="mb-3">Análisis de DRC del sobrante</h4>

                {estado && (
                    <div
                        className={`alert ${estado.alerta} text-center font-weight-bold`}
                    >
                        {estado.label}
                    </div>
                )}

                <div className="formulario-fields-row">
                    <div className="formulario-field text-center">
                        <label>Kg húmedos enviados</label>
                        <RenderKilogramo value={analisis.kg_humedos} />
                    </div>

                    <div className="formulario-field text-center">
                        <label>Fecha solicitud</label>
                        <span>
                            {analisis.fecha_solicitud_analisis
                                ? moment(
                                      analisis.fecha_solicitud_analisis,
                                  ).format("DD/MM/YYYY HH:mm")
                                : "N/A"}
                        </span>
                    </div>

                    {drcValidado && (
                        <React.Fragment>
                            <div className="formulario-field text-center">
                                <label>DRC laboratorio</label>
                                <RenderNumberPercentage
                                    value={analisis.drc}
                                    decimalScale={3}
                                />
                            </div>

                            <div className="formulario-field text-center">
                                <label>Kg secos</label>
                                <RenderKilogramo
                                    value={analisis.kg_humedos * analisis.drc}
                                />
                            </div>

                            <div className="formulario-field text-center">
                                <label>Fecha análisis</label>
                                <span>
                                    {analisis.fecha_analisis
                                        ? moment(
                                              analisis.fecha_analisis,
                                          ).format("DD/MM/YYYY")
                                        : "N/A"}
                                </span>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div>
    );
};
